import React from 'react';
import clsx from 'clsx';

export function Badge({ children, variant = 'default', className = '' }) {
  const baseStyle = 'inline-block px-2 py-1 text-xs font-medium rounded';

  const variantStyles = {
    default: 'bg-gray-200 text-gray-800',
    success: 'bg-green-500 text-white',
    error: 'bg-red-500 text-white',
    warning: 'bg-yellow-400 text-black',
  };

  return (
    <span className={clsx(baseStyle, variantStyles[variant], className)}>
      {children}
    </span>
  );
}
